export const calendarConfiguratorI18NPl = {
    showAll: "Pokaż wszystkie",
    hideAll: "Ukryj wszystkie",
    active: "Pokaż wszystkich użytkowników",
    addTeam: "Dodaj zespół",
    allTeams: "Wszystkie zespoły",
    myTeams: "Moje",
};
